import { render } from "./BasicExamples.vue?vue&type=template&id=221da8ff"
import script from "./BasicExamples.vue?vue&type=script&lang=ts"
export * from "./BasicExamples.vue?vue&type=script&lang=ts"
script.render = render

export default script